/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { usePersistShard, useShard } from "..";
export const useCluster = (data) => {
    var _a;
    let states = {};
    for (const item in data) {
        if (((_a = data[item]) === null || _a === void 0 ? void 0 : _a.getKey) !== undefined) {
            states[item] = () => usePersistShard(data[item]);
        }
        else {
            states[item] = () => useShard(data[item]);
        }
    }
    return states;
};
//# sourceMappingURL=useCluster.js.map